import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", {
      id: _ctx.id,
      class: _normalizeClass([
      'data-table__row',
      { clickable: _ctx.isClickable, collapsed: _ctx.isCollapsed }
    ]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCollapse && _ctx.onCollapse(...args))),
      ref: "dropdown"
    }, [
      _renderSlot(_ctx.$slots, "dropdown-row")
    ], 10, _hoisted_1),
    _renderSlot(_ctx.$slots, "default")
  ], 64))
}